export const usePwaInstall = () => {
  const canInstall = ref(false)
  const showIosPrompt = ref(false)
  const deferredPrompt = ref<any>(null)

  const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent)
  const isInstalled = () => window.navigator.standalone === true

  onMounted(() => {
    // For Android: listen to beforeinstallprompt
    const handleBeforeInstallPrompt = (e: Event) => {
      e.preventDefault()
      deferredPrompt.value = e
      canInstall.value = true
    }

    const handleAppInstalled = () => {
      canInstall.value = false
      deferredPrompt.value = null
    }

    // For iOS: show prompt if not already installed
    if (isIOS() && !isInstalled()) {
      showIosPrompt.value = true
    }

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
    window.addEventListener('appinstalled', handleAppInstalled)

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt)
      window.removeEventListener('appinstalled', handleAppInstalled)
    }
  })

  const install = async () => {
    if (!deferredPrompt.value) return

    deferredPrompt.value.prompt()
    const { outcome } = await deferredPrompt.value.userChoice

    if (outcome === 'accepted') {
      canInstall.value = false
      deferredPrompt.value = null
    }
  }

  const dismissIosPrompt = () => {
    showIosPrompt.value = false
  }

  return {
    canInstall: readonly(canInstall),
    showIosPrompt: readonly(showIosPrompt),
    isIOS,
    install,
    dismissIosPrompt
  }
}
